<div
  class="breadcrumb__header-box pb-3 pt-3 z-index-2"
  [ngClass]="{
    'breadcrumb__header-box--stuck': stuck$ | async
  }"
  title=""
>
  <div class="d-flex flex-sm-row flex-column" appContentContainerClass [ngClass]="{
    'justify-content-between': !withFilter
  }">
    <div  class="d-flex align-items-start flex-column">

      <h1
        class="text-dark fw-bolder mt-1 mb-2 fs-2"
      >
        <ng-container
          *ngIf="beforeTitleTemplate"
          [ngTemplateOutlet]="beforeTitleTemplate"
          [ngTemplateOutletContext] ="{}">
        </ng-container>

        <app-skeleton-loader
          *ngIf="isLoading; else titleTemplate"
          [inline]="true"
          class="w-100px"
        ></app-skeleton-loader>

        <ng-template #titleTemplate>
          <span test-id="breadcrumbs.title">{{ title | translate }}</span>
        </ng-template>
      </h1>
      <app-skeleton-loader
          *ngIf="isLoading; else breadcrumbsTemplate"
          [inline]="true"
          class="w-250px"
        ></app-skeleton-loader>

      <ng-template #breadcrumbsTemplate>
        <ol
          *ngIf="items"
          class="breadcrumb breadcrumb-dot text-muted fs-7 d-none d-sm-flex"
        >
          <li
            *ngFor="let item of items"
            class="breadcrumb-item"
            [ngClass]="{'text-muted fw-bold text-gray-900': !item.link}"
          >
            <a
              *ngIf="item.link; else noLink"
              [routerLink]="item.link"
              class="text-gray-600"
            >
              {{ item.title | translate }}
            </a>
            <ng-template #noLink>
              {{ item.title | translate }}
            </ng-template>
          </li>
        </ol>
      </ng-template>
    </div>
    <div class="d-flex align-items-center"
      [ngClass]="{'ps-20 flex-grow-1': withFilter}"
    >
      <ng-content select="[centralBox]"></ng-content>
    </div>
    <div class="d-flex align-items-center">
      <ng-content></ng-content>
    </div>
  </div>

</div>
